import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
    getBilateralLedgerOngoing, 
    getRALedgerOngoing,
    getCBLedgerOngoing
} from "../../Services/ApiCalling/unifiedLedger"


export const fetchBilateralLedgerOngoing = createAsyncThunk(
  "unifiedLedger/fetchBilateralLedgerOngoing",
  async ({ currentPage = 0, size = 100 }, { rejectWithValue }) => {
    try {
      const response = await getBilateralLedgerOngoing(currentPage, size);

      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch unified ledger data"
      );
    }
  }
);

export const fetchRALedgerOngoing = createAsyncThunk(
  "unifiedLedger/fetchRALedgerOngoing",
  async ({ currentPage = 0, size = 100 }, { rejectWithValue }) => {
    try {
      const response = await getRALedgerOngoing(currentPage, size);
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch RA ledger data"
      );
    }
  }
);

export const fetchCBLedgerOngoing = createAsyncThunk(
  "unifiedLedger/fetchCBLedgerOngoing",
  async ({ currentPage = 0, size = 100 }, { rejectWithValue }) => {
    try {
      const response = await getCBLedgerOngoing(currentPage, size);
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch RA ledger data"
      );
    }
  }
);

const unifiedLedgerSlice = createSlice({
  name: "unifiedLedger",
  
  initialState: {
    // State to store the fetched data, usually includes pagination details
    bilateralLedgerOngoingData: {
    code: null,
    message: "",
    data: {
      page: [],
      totalElements: 0,
      size: 10,
      totalPages: 0,
      currentPage: 0,
    },
    },
  raLedgerOngoingData: {
    code: null,
    message: "",
    data: {
      page: [],
      totalElements: 0,
      size: 10,
      totalPages: 0,
      currentPage: 0,
    },
    },
    cbLedgerOngoingData: {
    code: null,
    message: "",
    data: {
      page: [],
      totalElements: 0,
      size: 10,
      totalPages: 0,
      currentPage: 0,
    },
    },
    loading: false, // General loading indicator for the slice's operations
    error: null, // General error storage
  },

//   reducers: {
//     // Synchronous reducers go here if needed.
//     // Example:
//     clearOngoingLedgerData: (state) => {
//       state.bilateralLedgerOngoingData = {
//         page: [],
//         currentPage: 0,
//         size: 10,
//         totalElements: 0,
//         totalPages: 0,
//       };
//       state.error = null;
//     }
//   },

//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchBilateralLedgerOngoing.pending, (state) => {
//         state.loading = true;
//         state.error = null; 
//       })
//       .addCase(fetchBilateralLedgerOngoing.fulfilled, (state, action) => {
//         state.loading = false;
//         state.bilateralLedgerOngoingData = action.payload; 
//       })
//       .addCase(fetchBilateralLedgerOngoing.rejected, (state, action) => {
//         state.loading = false;
//         //storing error message sent by rejectByValue
//         state.error = action.payload || "An unknown error occurred."; 
//         // Optionally reset data on failure
//         // state.bilateralLedgerOngoingData.page = [];
//       });
//   },

extraReducers: (builder) => {
  builder
    .addCase(fetchBilateralLedgerOngoing.pending, (state) => {
      state.bilateralLedgerOngoingData.loading = true;
      state.bilateralLedgerOngoingData.error = null;
    })
    .addCase(fetchBilateralLedgerOngoing.fulfilled, (state, action) => {
      state.bilateralLedgerOngoingData.loading = false;
      state.bilateralLedgerOngoingData.code = action.payload.code;
      state.bilateralLedgerOngoingData.message = action.payload.message;
      state.bilateralLedgerOngoingData.data = action.payload.data;
      state.bilateralLedgerOngoingData.error = null;
    })
    .addCase(fetchBilateralLedgerOngoing.rejected, (state, action) => {
      state.bilateralLedgerOngoingData.loading = false;
      state.bilateralLedgerOngoingData.error =
        action.payload || "An unknown error occurred.";
    })
    .addCase(fetchRALedgerOngoing.pending, (state) => {
     state.raLedgerOngoingData.loading = true;
     state.raLedgerOngoingData.error = null;
    })
    .addCase(fetchRALedgerOngoing.fulfilled, (state, action) => {
     state.raLedgerOngoingData.loading = false;
     state.raLedgerOngoingData.code = action.payload.code;
     state.raLedgerOngoingData.message = action.payload.message;
     state.raLedgerOngoingData.data = action.payload.data;
     state.raLedgerOngoingData.error = null;
    })
    .addCase(fetchRALedgerOngoing.rejected, (state, action) => {
     state.raLedgerOngoingData.loading = false;
     state.raLedgerOngoingData.error =
     action.payload || "An unknown error occurred.";
    })
     .addCase(fetchCBLedgerOngoing.pending, (state) => {
     state.cbLedgerOngoingData.loading = true;
     state.cbLedgerOngoingData.error = null;
    })
    .addCase(fetchCBLedgerOngoing.fulfilled, (state, action) => {
     state.cbLedgerOngoingData.loading = false;
     state.cbLedgerOngoingData.code = action.payload.code;
     state.cbLedgerOngoingData.message = action.payload.message;
     state.cbLedgerOngoingData.data = action.payload.data;
     state.cbLedgerOngoingData.error = null;
    })
    .addCase(fetchCBLedgerOngoing.rejected, (state, action) => {
     state.cbLedgerOngoingData.loading = false;
     state.cbLedgerOngoingData.error =
     action.payload || "An unknown error occurred.";
    });
},
});

// // Export synchronous actions (reducers)
// export const { clearOngoingLedgerData } = unifiedLedgerSlice.actions;

// Export the reducer for the store configuration
export default unifiedLedgerSlice.reducer;